module.exports = __webpack_public_path__ + "img/img2.6c80c901.png";